import IdleTimer from 'exacta-material-react/lib/src/components/IdleTimer';
import { TCTWindow } from 'nots-window-renderer';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { ComposedActions } from '../../../helpers/actions';
import { IdleTimeout, S80Monitors } from '../../../helpers/constants';
import { DemoInteractionBlocker } from '../../common-components/DemoInteractionBlocker';
import GuidedContainer from '../../common-components/GuidedContainer';
import { MultimediaInteractionBlocker } from '../../common-components/MultimediaBlocker';
import { PauseOverlay } from '../../common-components/PauseOverlay';
import StartLesson from '../../common-components/StartLesson';
import MultimediaDialog from '../../MultimediaDialog';
import MonitorContext from '../../S80/MonitorContext';
import { HermesysColors } from '../Colors';

interface ITCTProps {}

const TCTSizes = {
  main: {
    width: 800,
    height: 500,
  },
};

const TitleBar = styled.div`
  padding: 10px;
`;

const Container = styled.div`
  width: ${TCTSizes.main.width}px;
  height: ${TCTSizes.main.height}px;
  background: ${HermesysColors.main.background};
  color: ${HermesysColors.White};
  font-family: Lucida Sans Typewriter;
`;

export function TCTWindowManager(props: ITCTProps) {
  const dispatch = useDispatch();

  const onButtonClick = (key: string) => {};
  const onCallButtonClick = (key: string, value: string) => {
    dispatch(
      ComposedActions.TCTPhoneWindowDialPhone.aCreator({
        id: key,
        value,
      })
    );
  };
  const onCallListItemSelect = (
    key: string,
    value: string,
    isSelected: boolean
  ) => {
    dispatch(
      ComposedActions.TCTSelectPhoneListItem.aCreator({
        id: key,
        value,
        isSelected,
      })
    );
  };
  const onMainButtonClick = (key: string) => {
    dispatch(
      ComposedActions.TCTMainWindowButtonClick.aCreator({
        id: key,
      })
    );
  };
  const onPhoneButtonClick = (key: string) => {
    dispatch(
      ComposedActions.TCTPhoneWindowButtonClick.aCreator({
        id: key,
      })
    );
  };
  const onSelectCommunicationUser = (key: string) => {
    dispatch(
      ComposedActions.TCTSelectCommunicationUser.aCreator({
        id: key,
      })
    );
  };
  const onPhoneListButtonClick = (key: string) => {
    dispatch(
      ComposedActions.TCTPhoneListWindowButtonClick.aCreator({
        id: key,
      })
    );
  };
  const onConfigButtonClick = (key: string) => {
    dispatch(
      ComposedActions.TCTSettingsConfigWindowButtonClick.aCreator({
        id: key,
      })
    );
  };
  const onSettingsButtonClick = (key: string) => {
    dispatch(
      ComposedActions.TCTSettingsWindowButtonClick.aCreator({
        id: key,
      })
    );
  };

  const onPhoneListClick = (key: string) => {
    dispatch(
      ComposedActions.TCTPhoneListClick.aCreator({
        id: key,
      })
    );
  };

  const onSettingsActivateButtonClick = (key: string, value: string) => {
    dispatch(
      ComposedActions.TCTSettingsConfigWindowActivateCode.aCreator({
        id: key,
        value,
      })
    );
  };

  const { windowId, ...otherData } = useSelector(
    (state: any) => state.executor.tct
  );

  return (
    <Container>
      <MonitorContext.Provider
        value={{
          monitor: S80Monitors.UPPER,
        }}
      >
        <TitleBar>Navantia Communication Control System - </TitleBar>
        <StartLesson preferredDialogMonitor="upper" />
        <PauseOverlay />
        <DemoInteractionBlocker />
        <MultimediaInteractionBlocker />
        <IdleTimer timeout={IdleTimeout} logoutOnTimeout={false} />
        <GuidedContainer data-area="guided-container" />
        <MultimediaDialog />
        <TCTWindow
          onButtonClick={onButtonClick}
          onCallButtonClick={onCallButtonClick}
          onCallListItemSelect={onCallListItemSelect}
          windowId={windowId}
          otherData={otherData}
          onMainButtonClick={onMainButtonClick}
          onPhoneButtonClick={onPhoneButtonClick}
          onSelectCommunicationUser={onSelectCommunicationUser}
          onPhoneListClick={onPhoneListClick}
          onPhoneListButtonClick={onPhoneListButtonClick}
          onConfigButtonClick={onConfigButtonClick}
          onSettingsButtonClick={onSettingsButtonClick}
          onSettingsActivateButtonClick={onSettingsActivateButtonClick}
        />
      </MonitorContext.Provider>
    </Container>
  );
}
